import { Controller } from "stimulus";

export default class MultievaluatedFormController extends Controller {
  appendItem(e) {
    e.preventDefault();
    const formContainer = e.target.parentElement.querySelector(".js-form-section");
    const template = formContainer.querySelector(".js-item-template");

    if (!template) {
      console.error("Template not found");
      return;
    }

    const newForm = template.content.cloneNode(true);
    const salt = window.salt();

    const itemContainer = newForm.querySelector(".js-item-container");
    itemContainer.setAttribute("data-item-appended", salt);
    itemContainer.style.viewTransitionName = `form-section-${salt}`;

    newForm.querySelectorAll("label,input, textarea, select, checkbox").forEach((element) => {
      const elementName = element.getAttribute("name");
      const elementId = element.getAttribute("id");
      if (elementName && elementId) {
        element.setAttribute("name", elementName.replaceAll(/PLACEHOLDER/g, salt))
        element.setAttribute("id", elementId.replaceAll(/PLACEHOLDER/g, salt))
      }
      if (element.hasAttribute("for")) {
        element.setAttribute("for", element.getAttribute("for").replaceAll(/PLACEHOLDER/g, salt));
      }
    })

    const appendEvent = new CustomEvent("multievaluated:item-appended", { detail: `[data-item-appended='${salt}']` });

    if (!document.startViewTransition) {
      formContainer.appendChild(newForm);
      formContainer.dispatchEvent(appendEvent);
      return;
    }

    document.startViewTransition(() => {
      formContainer.appendChild(newForm);
      formContainer.dispatchEvent(appendEvent);
    });
  }

  removeItem(e) {
    e.preventDefault();
    const trigger = e.currentTarget;
    const isElementPersisted = trigger?.hasAttribute("data-persisted");

    const container = trigger.closest(".js-item-container");
    if (!container) return;

    if (!isElementPersisted) {
      if (!document.startViewTransition) {
        container.remove();
        return;
      }

      document.startViewTransition(() => {
        container.remove();
      });
      return;
    }

    const destroyInputEl = container.querySelector("input[name*=_destroy]");

    if (destroyInputEl) {
      destroyInputEl.value = 1;
      this._cleanFields(container);

      // Set the company name input to indicate it was removed
      const companyNameInput = container.querySelector('.js-companies-autocomplete');
      if (companyNameInput) {
        const originalValue = companyNameInput.value || companyNameInput.dataset.initialSearch || "Unknown";
        companyNameInput.value = `${originalValue} (Removed)`;
      }

      if (!document.startViewTransition) {
        container.style.display = "none";
        return;
      }

      document.startViewTransition(() => {
        container.style.display = "none";
      });
    }
  }

  _cleanFields (container) {
    const items = container.querySelectorAll("input[type=text], select, textarea, input[type=checkbox]");
    items.forEach(item => {
      if (item.type === "checkbox") {
        item.checked = false;
        return;
      }
      item.value = ""
    })
  }
}
